import { Network, NetworkPublicInfo } from '@tribeplatform/gql-client/types'

const getSubdomain = (domainSubfolder: string, networkDomain: string) => {
  try {
    if (domainSubfolder) {
      const url = new URL(`https://${domainSubfolder}`)
      return {
        subfolder: url?.pathname === '/' ? '' : url?.pathname,
        domain: url?.host || networkDomain,
      }
    }
  } catch (err) {
    // TODO: Throw error instead of catching it. Let the consumer handle it.
  }
  return { subfolder: '', subfolderDomain: null, domain: networkDomain }
}

export const getOriginURLs = (
  networkDomain: string,
  hostDomain: string,
  subfolder: string,
) => {
  if (!subfolder) {
    return [`${networkDomain}`]
  }

  if (networkDomain === hostDomain) {
    return [`${networkDomain}${subfolder}`]
  }

  if (subfolder) {
    return [`${networkDomain}${subfolder}`, `${hostDomain}${subfolder}`]
  }
}

export type DomainPathInfo = {
  domain: string
  /**
   * The subfolder which the community is installed on.
   * If community is accessible at the root of domain, it's an empty string.
   * Otherwise, it has a leading slash without trailing slash. (e.g. `/hub`)
   */
  subfolder: string
  /**
   * A normalized version of the subfolder, with trailing slash,
   * that can be provided to the router for consistent routing
   */
  basename: string
  /**
   * When dealing with subfolder communities, API won't recognize the domain
   * if the domain that is associated with the subfolder is not the same as the
   * one stored in the domain property. We need a way to make the original domain
   * available for related operations.
   */
  originalDomain: string
}

export const getDomainInfo = (network: Network | NetworkPublicInfo) => {
  const domainSubfolder = network?.domainSubfolder || network?.domain
  const { subfolder, domain } = getSubdomain(domainSubfolder, network?.domain)
  const basename = subfolder?.endsWith('/') ? subfolder : `${subfolder || ''}/`

  return {
    domain,
    subfolder,
    basename,
    originalDomain: network?.domain,
  }
}
